import { Grid, Skeleton, TextField, IconButton, FormHelperText } from '@mui/material';
import { useContext, useEffect } from 'react';
import { useState } from 'react';
import { ValidateContext } from 'components/form/ValidateContext';
import ClearIcon from '@mui/icons-material/Clear';
import UploadButton from 'components/button/UploadButton';
import { Box } from '@mui/system';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';

const style = {
    width: 'auto',
    overflow: 'hidden'
};

export const FormImgFileInput = ({ defaultValue, name, loading, ...props }) => {
    const [img, setimg] = useState();
    const { error } = useContext(ValidateContext);
    const fileHandler = (e) => {
        const { files, name, value } = e.target;
        setimg(files || files[0]);
    };

    return (
        <>
            {loading ? (
                <Skeleton animation="wave" height={60} sx={{ borderRadius: '12px' }} />
            ) : (
                <>
                    <TextField
                        fullWidth
                        id={name}
                        name={img ? name : ''}
                        type="file"
                        error={Object.keys(error).includes(name)}
                        helperText={Object.keys(error).includes(name) ? error[name] : ''}
                        onChange={fileHandler}
                        defaultValue={null}
                        {...props}
                    />
                </>
            )}
            {loading ? (
                <Skeleton
                    animation="wave"
                    sx={{
                        width: '70%',
                        height: '200px',
                        border: 1,
                        borderRadius: '16px',
                        mt: 2,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        overflow: 'hidden'
                    }}
                />
            ) : (
                <Grid
                    sx={{
                        width: '70%',
                        height: '200px',
                        background: '#bbb',
                        borderColor: 'grey',
                        border: 1,
                        borderRadius: '16px',
                        mt: 2,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        overflow: 'hidden'
                    }}
                >
                    {!(img || (defaultValue?.length > 0 && defaultValue[0]?.url)) && <span>PHOTO</span>}
                    {(img || (defaultValue?.length > 0 && defaultValue[0]?.url)) && (
                        <img
                            src={img ? URL.createObjectURL(img[0]) : `${process.env.REACT_APP_PM_CONTEXT_URL}${defaultValue[0].url}`}
                            alt="profile_photo"
                            style={{ width: 'auto', height: '100%' }}
                        />
                    )}
                </Grid>
            )}
        </>
    );
};

export const ImgFileInput = ({ defaultValue, name, loading, ...props }) => {
    const [img, setimg] = useState();
    const [defaultImage, setDefaultImage] = useState({});
    const { error } = useContext(ValidateContext);

    const fileHandler = (e) => {
        const { files } = e.target;
        setimg(files && files[0]);
    };

    const handleClearImage = () => {
        setimg(null);
        setDefaultImage(null);
    };

    useEffect(() => {
        handleClearImage();
        setDefaultImage(defaultValue); // Update the defaultImage state when defaultValue changes
    }, [defaultValue]);

    return (
        <>
            {loading ? (
                <Skeleton animation="wave" height={51} sx={{ borderRadius: '12px' }} />
            ) : (
                <TextField
                    fullWidth
                    id={name}
                    name={img ? name : ''}
                    type="file"
                    error={Object.keys(error).includes(name)}
                    helperText={Object.keys(error).includes(name) ? error[name] : ''}
                    onChange={fileHandler}
                    defaultValue={defaultImage?.url}
                    inputProps={{ accept: 'image/png, image/gif, image/jpeg, image/jpg' }}
                    {...props}
                    InputProps={{
                        endAdornment: (
                            <>
                                <IconButton onClick={handleClearImage} size="small">
                                    <ClearIcon />
                                </IconButton>
                            </>
                        )
                    }}
                />
            )}
            {loading ? (
                <Skeleton
                    animation="wave"
                    sx={{
                        width: '70%',
                        height: '200px',
                        border: 1,
                        borderRadius: '16px',
                        mt: 2,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        overflow: 'hidden'
                    }}
                />
            ) : (
                <Grid
                    sx={{
                        width: '70%',
                        height: '200px',
                        background: '#bbb',
                        borderColor: 'grey',
                        border: 1,
                        borderRadius: '16px',
                        mt: 2,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        overflow: 'hidden'
                    }}
                >
                    {!img && !defaultImage?.url && <span>PHOTO</span>}
                    {(img || defaultImage?.url) && (
                        <>
                            <img
                                src={img ? URL.createObjectURL(img) : process.env.REACT_APP_PM_CONTEXT_URL + defaultImage?.url}
                                alt="single_photo"
                                style={{ width: 'auto', height: 'auto', maxHeight: '100%', maxWidth: '100%' }}
                            />
                            {img && (
                                <IconButton onClick={handleClearImage} size="small" sx={{ position: 'absolute', top: '8px', right: '8px' }}>
                                    <ClearIcon />
                                </IconButton>
                            )}
                        </>
                    )}
                </Grid>
            )}
        </>
    );
};

export const ImgFileUploader = ({ name, loading, onChange, onDelete, inputProps = { accept: '' }, value, type, alt, size, error }) => {
    return loading ? (
        <Skeleton animation="wave" height={60} sx={{ borderRadius: '12px' }} />
    ) : (
        <Grid container gap={1}>
            <Grid item>
                <input type="file" id={name || 'thumbnail'} style={{ display: 'none' }} multiple {...inputProps} onChange={onChange} />
                <label htmlFor={name || 'thumbnail'} style={{ width: '120px', display: 'block' }}>
                    <UploadButton />
                </label>
                {error && <FormHelperText error>{error || ''}</FormHelperText>}
            </Grid>
            {value && (
                <Grid item display={'flex'} alignItems={'end'}>
                    <Box style={{ ...style, height: `${size === 'small' ? '50px' : '200px'}` }}>
                        <img
                            src={type === 'local' ? URL.createObjectURL(value) : process.env.REACT_APP_PM_CONTEXT_URL + value?.url}
                            alt={alt || 'photo'}
                            style={{ width: 'auto', height: '100%' }}
                        />
                    </Box>
                    <DeleteForeverIcon onClick={() => onDelete()} sx={{ cursor: 'pointer', color: '#ea0606' }} />
                </Grid>
            )}
        </Grid>
    );
};
